<template>
  <div class="newsletter-inner">
    <div class="form-wrapper">
      <h4>{{ title }}</h4>

      <span v-show="errors.has('email') && submitted" class="form-error">{{
        errors.first("email")
      }}</span>
      <div class="input-group">
        <input
          :placeholder="this.$translations.newsletter.email_placeholder"
          id="email"
          type="email"
          name="email"
          v-model="form.email"
        />
        <button
          class="btn-submit"
          :class="{ 'btn-loading': loading }"
          @click.prevent="submit"
        >
          {{ this.$translations.newsletter.submit }}
        </button>
      </div>
      <div class="terms">
        <div class="checkbox-wrapper">
          <input
            v-model="agreed_terms.status"
            type="checkbox"
            name="conditions"
            id="conditions"
            @change="agreed_terms.error = false"
          />
          <a target="_blank" :href="terms">
            {{ this.$translations.cart.terms_text_long }}
          </a>
        </div>
        <div class="form-error" v-if="agreed_terms.error">
          {{ this.$translations.cart.terms_error }}
        </div>
      </div>

      <div class="form-success" v-if="success">
        {{ this.$translations.newsletter.confirmation }}
      </div>

      <div class="form-error" v-if="error">
        {{ this.$translations.newsletter.error }}
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VeeValidate, { Validator } from "vee-validate";
import axios from "axios";

Vue.use(VeeValidate);

export default {
  props: ["title", "terms"],
  data() {
    return {
      form: {
        email: "",
        list_id: "46a83c48a3",
      },
      loading: false,
      error: false,
      submitted: false,
      success: false,
      agreed_terms: {
        status: false,
        error: false,
      },
    };
  },
  methods: {
    submit() {
      this.submitted = true;
      this.error = false;
      this.$validator.validateAll().then((isValid) => {
        if (isValid && this.agreed_terms.status) {
          this.subscribe();
        } else if (!this.agreed_terms.status) {
          this.agreed_terms.error = true;
        }
      });
    },
    async subscribe() {
      let formData = new FormData();
      Object.keys(this.form).forEach((key) =>
        formData.append(key, this.form[key])
      );

      if (!this.loading) {
        try {
          this.loading = true;
          await axios.post(
            "https://mailer.signifly.com/api/klassik-newsletter/mailchimp",
            formData
          );
          this.success = true;
        } catch (e) {
          this.loading = false;
          this.error = true;
        } finally {
          (this.form = {
            email: "",
            list_id: "46a83c48a3",
          }),
            (this.agreed_terms = {
              status: false,
              error: false,
            });
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.newsletter-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #f6f6f8;
  padding: 55px 0;

  @include res(tab-p) {
    padding: 45px 20px;
  }

  .form-wrapper {
    width: 330px;
    text-align: center;

    @include res(tab-p) {
      width: 100%;
    }

    h4 {
      color: $medium-grey;
      font-size: 12px;
      line-height: 25px;
      margin-bottom: 15px;
      text-transform: uppercase;
      font-family: $font-text-heavy;
      font-weight: lighter;
    }

    .input-group {
      display: flex;
      width: 100%;

      @include res(tab-p) {
        flex-direction: column;
      }

      input {
        border: 1px solid #798395;
        height: 40px;
        margin-right: 10px;
        padding: 0 10px;
        font-size: 12px;
        width: 70%;
        font-family: $font-text;

        @include res(tab-p) {
          width: 100%;
          margin: 0;
        }
      }

      button {
        @include button(#ffffff, 0, 25px);
        background-color: $dark-grey;
        text-transform: uppercase;
        height: 40px;
        border: none;

        &::before {
          @include button-hover($bg: #5C5C5C);
        }

        @include res(tab-p) {
          width: 100%;
          margin-top: 10px;
        }
      }
    }
  }

  .terms {
    @include terms;
  }

  .form-success,
  .form-error {
    text-align: left;
  }
}
</style>
